const StoryFeed = () => import(/* webpackChunkName: "PageStoryFeed" */ '@/components/Pages/StoryFeed')
const StoryView = () => import(/* webpackChunkName: "SectionStoryView" */ '@/components/SectionProjectView/Story')
const ArticleRedirect = () => import(/* webpackChunkName: "ArticleRedirect" */ '@/components/Pages/ArticleRedirect')
const Resources = () => import(/* webpackChunkName: "PageResources" */ '@/components/Pages/Resources')
const FAQ = () => import(/* webpackChunkName: "FAQ" */ '@/components/Pages/FAQ')

module.exports = [
  {
    path: '/:partner?/story/:id',
    name: 'viewStory',
    component: StoryView,
    meta: { hideFooter: false }
  },
  {
    path: '/:partner?/story/video/:id',
    name: 'storyFeed',
    component: StoryFeed,
    meta: { hideFooter: false }
  },
  {
    path: '/:partner?/FAQ',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/:partner?/resource/:id',
    name: 'viewResource',
    component: StoryView,
    meta: { hideFooter: false }
  },
  {
    path: '/:partner?/article/:id',
    name: 'articleRedirect',
    component: ArticleRedirect,
    meta: { requiresAuth: false }
  },
  {
    path: '/:partner?/article/-1',
    alias: '/article'
  },
  {
    path: '/:partner?/resources/:resourceSlug',
    name: 'resourcesType',
    component: Resources,
    meta: { requiresAuth: false }
  },
  {
    path: '/:partner?/resources/:resourceSlug/:resourceSort',
    name: 'resourcesTypeSort',
    component: Resources,
    meta: { requiresAuth: false }
  }
]
